/**
 * @desc 获取明细
 */
const URL = "/rantion-fulfilment";
import http, { updateResponse } from "@/http";
export function request(params: API.fulfilment.warehouseMaster.getDetail.Params, options?: any) {
  return updateResponse(
    http(URL + `/fulfilment/warehouseMaster/getDetail`, {
      method: "GET",
      params,

      ...options,
    }),
  );
}
